import I18n from "./I18n";

export function convertDurationToReadable(duration: number) {
  let ret = "";
  const units = [
    { label: "second", max: 60 },
    { label: "minute", max: 60 },
    { label: "hour", max: 24 },
    { label: "day", max: 365 },
  ] as const;
  let nextDuration = duration;
  for (const { label, max } of units) {
    const rest = nextDuration % max;
    ret = `${Number.isInteger(rest) ? rest : rest.toFixed(3)}${I18n.t(
      `units.${label}`,
    )}${ret}`;
    if (nextDuration < max) {
      break;
    }
    nextDuration = parseInt(((nextDuration - rest) / max).toFixed(), 10);
  }
  return ret;
}

export function convertBytesToReadable(bytes: number) {
  const units = ["B", "KB", "MB", "GB", "TB"];
  let nextBytes = bytes;
  let usingUnit = "";
  for (const unit of units) {
    if (nextBytes < 1024) {
      usingUnit = unit;
      break;
    }
    nextBytes /= 1024;
  }
  return `${nextBytes.toFixed(2)} ${usingUnit}`;
}
